import axios from 'axios';
const base = 'usernotifyemail';

function getAll() {
    return axios.get(base);
}

function register(data) {
    return axios.post(base, data);
}

const UserNotifyEmailService = { getAll, register };
export default UserNotifyEmailService;
